import { IEventsStore } from '../index'

export default function(state: IEventsStore, action): IEventsStore {
  return {
    ...state,
    eventId: action.eventId,
    pdf: '',
    pdfRequest: {
      ...state.pdfRequest,
      errMessage: '',
      isLoading: true,
    },
  }
}
